"use client";
import { motion, AnimatePresence } from "motion/react";
import Image from "next/image";

export default function Preloader() {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-orange-50 via-amber-50 to-orange-100"
      >
        {/* Tricolor stripe on top */}
        <div className="absolute top-0 left-0 right-0 h-2 flex">
          <div className="flex-1 bg-orange-500"></div>
          <div className="flex-1 bg-white"></div>
          <div className="flex-1 bg-green-600"></div>
        </div>

        <div className="text-center">
          {/* Animated Statue Silhouette */}
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="mb-4"
          >
            <div className="relative w-32 h-48 mx-auto">
              <motion.div
                transition={{ duration: 2, repeat: Infinity }}
                className="absolute inset-0 rounded-t-full"
                // style={{
                //   clipPath:
                //     "polygon(40% 0%, 60% 0%, 65% 30%, 70% 100%, 30% 100%, 35% 30%)",
                // }}
              >
                <img
                  src={"/sou.png"}
                  alt="logo"
                  width={100}
                  height={100}
                  className="w-[150px] h-full object-cover"
                />
              </motion.div>
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            <h2 className="text-3xl font-bold bg-gradient-to-r from-orange-600 via-amber-600 to-orange-600 bg-clip-text text-transparent mb-2">
              Statue of Unity
            </h2>
            <p className="text-gray-600 text-sm mb-6">
              Tribute to Sardar Vallabhbhai Patel
            </p>
          </motion.div>

          {/* Loading bar */}
          <div className="w-64 h-1 bg-gray-200 rounded-full overflow-hidden mx-auto">
            <motion.div
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 1.3, ease: "easeInOut" }}
              className="h-full bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600"
            />
          </div>

          {/* Unity in Diversity text */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
            className="mt-6 text-xs text-gray-500 italic"
          >
            "Unity in Diversity"
          </motion.p>
        </div>

        {/* Tricolor stripe on bottom */}
        <div className="absolute bottom-0 left-0 right-0 h-2 flex">
          <div className="flex-1 bg-orange-500"></div>
          <div className="flex-1 bg-white"></div>
          <div className="flex-1 bg-green-600"></div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
